module.exports = __webpack_public_path__ + "static/media/zoomAttendancePreviewImage.e2840778.png";